import React from 'react';
const DiffMatchPatch = require('diff-match-patch');
import './style.css';

const splitDiff = function(diff) {
    let result = [];
    const [type, value] = diff;
    let start = 0;
    let index = value.indexOf('\n', start);
    if (index >= 0) {
        while (index >= 0) {
            const fragment = value.substring(start, index);
            if (fragment) {
                result.push([type, fragment]);
            }
            result.push([type, '\n']);
            start = index + 2;
            index = value.indexOf('\n', start);
        }
    }
    const fragment = value.substring(start);
    if (fragment) {
        result.push([type, fragment]);
    }
    return result;
};

const splitDiffs = function(diffs) {
    let result = [];
    for (let diff of diffs) {
        result = result.concat(splitDiff(diff));
    }
    return result;
};

const groupDiff = function(diffs) {
    let group = [];
    let groupItem = { type: 0, items: [] };
    for (let diff of diffs) {
        if (diff[0] === 0 && diff[1] === '\n') {
            group.push(groupItem);
            groupItem = { type: 0, items: [] };
        } else {
            if (diff[0] !== 0) {
                groupItem.type = 1;
            }
            groupItem.items.push(diff);
        }
    }
    group.push(groupItem);
    return group;
};

const renderGroups = function(before, after) {
    const dmp = new DiffMatchPatch();
    dmp.Diff_Timeout = 1;
    dmp.Diff_EditCost = 4;
    let diffs = dmp.diff_main(before, after);
    dmp.diff_cleanupSemantic(diffs);
    const list = groupDiff(splitDiffs(diffs));
    return list.map((item, index) => {
        return (
            <div className={'diffContainer' + ' ' + (item.type ? 'modify' : '')}>
                <div className={'diffBefore'}>
                    <div className={'inner'}>
                        <div className={'count'}>
                            <div className={'content'}>{index + 1}</div>
                            <div className={'line'} />
                        </div>
                        <div className={'main'}>
                            <div className={'content'}>{renderDiff(item.items)}</div>
                            <div className={'line'} />
                        </div>
                    </div>
                </div>
                <div className={'diffAfter'}>
                    <div className={'inner'}>
                        <div className={'count'}>
                            <div className={'content'}>{index + 1}</div>
                            <div className={'line'} />
                        </div>
                        <div className={'main'}>
                            <div className={'content'}>{renderDiff(item.items)}</div>
                            <div className={'line'} />
                        </div>
                    </div>
                </div>
            </div>
        );
    });
};

const renderDiff = function(diffs) {
    return diffs.map(diff => {
        const content = diff[1] === '\n' ? <br /> : diff[1];
        switch (diff[0]) {
            case 0:
                return <span>{content}</span>;
            case 1:
                return <ins className={diff[1] === '\n' ? '' : 'modifyItem'}>{content}</ins>;
            case -1:
                return <del className={diff[1] === '\n' ? '' : 'modifyItem'}>{content}</del>;
        }
    });
};

class Comp extends React.Component {
    clickHandle() {}
    render() {
        const view = renderGroups(this.props.before, this.props.after);
        return <div onClick={this.clickHandle}>{view}</div>;
    }
}

export default Comp;

// 对选中内容进行标记相关的代码。
// function getDomindex(container, dom) {
//     let index = 0;
//     let result = NaN;
//     const getIndex = (container, dom) => {
//         if (container === dom) {
//             result = index;
//         } else if (container.childNodes) {
//             for (let child of container.childNodes) {
//                 index++;
//                 getIndex(child, dom);
//             }
//         }
//     };
//     getIndex(container, dom);
//     return result;
// }

// function getDomFromIndex(container, domIndex) {
//     let index = 0;
//     let result = null;
//     const getFromIndex = (container, domIndex) => {
//         if (domIndex === index) {
//             result = container;
//         } else if (container.childNodes) {
//             for (let child of container.childNodes) {
//                 index++;
//                 getFromIndex(child, domIndex);
//             }
//         }
//     };
//     getFromIndex(container, domIndex);
//     return result;
// }

// const markOne = function(selection) {
//     const range = selection.getRangeAt(0);
//     const rects = range.getClientRects();
//     for (let rect of rects) {
//         const div = document.createElement('div');
//         div.style.position = 'absolute';
//         div.style.top = window.scrollY + rect.top + 'px';
//         div.style.left = rect.left + 'px';
//         div.style.width = rect.width + 'px';
//         div.style.height = rect.height + 'px';
//         div.style.backgroundColor = 'red';
//         div.style.opacity = '0.3';
//         div.style.pointerEvents = 'none';
//         document.body.appendChild(div);
//     }
// };

// const markLayer = function(val) {
//     const selection = document.getSelection();
//     selection.empty();
//     while (window.find(val)) {
//         markOne(selection);
//     }
//     selection.empty();
//     window.scrollTo(0, 0);
// };

// const markInjection = function(val, container, background, color) {
//     const ss = document.getSelection();
//     ss.empty();
//     while (window.find(val)) {
//         const range = ss.getRangeAt(0);
//         const span = document.createElement('span');
//         span.style.backgroundColor = 'red';
//         span.style.color = 'white';
//         try {
//             range.surroundContents(span);
//         } catch (e) {}
//     }
//     ss.empty();
//     window.scrollTo(0, 0);
// };

// const markInjectionExec = function(val, container, backgroundColor, fontColor) {
//     const selection = document.getSelection();
//     container.contentEditable = true;
//     selection.empty();
//     while (window.find(val)) {
//         document.execCommand('BackColor', false, backgroundColor);
//         document.execCommand('ForeColor', false, fontColor);
//     }
//     selection.empty();
//     container.contentEditable = false;
//     window.scrollTo(0, 0);
// };

// const markIndex = function(val, index, container) {
//     const selection = document.getSelection();
//     const indexRange = document.createRange();
//     indexRange.setStart(container, 0);
//     selection.empty();
//     while (window.find(val)) {
//         indexRange.setEnd(selection.anchorNode, selection.anchorOffset);
//         const currentIndex = indexRange.toString().length;
//         console.log(currentIndex);
//         if (currentIndex === index) {
//             markOne(selection);
//             break;
//         }
//     }
//     selection.empty();
//     window.scrollTo(0, 0);
// };

// const getIndexBaseContainer = function (container) {
//     const selection = document.getSelection();
//     if (selection.anchorNode) {
//         const indexRange = document.createRange();
//         indexRange.setStart(container, 0);
//         indexRange.setEnd(selection.anchorNode, selection.anchorOffset);
//         return indexRange.toString().length;
//     } else {
//         return -1;
//     }
// };



// WEBPACK FOOTER //
// ./pages/task/tasklist/diff.js